const checkIfCBFund = (invTypeNmbr) => {
    const creditBalFundInvNmbr = [111, 319, 416]
    
    return creditBalFundInvNmbr.includes(invTypeNmbr);
}

export default checkIfCBFund;